/** Everything except the page cursor that decides which schedules match. */
export interface IWorkItemScheduleFilterState {
  familyId: string | null;
  hideArchived: boolean;
}

/**
 * Identity of a filter set, ignoring the page cursor — the Items tab's
 * `workItemFilterSignature` carries the full reasoning for why a caller needs
 * to tell a page turn from a filter change.
 */
export function workItemScheduleFilterSignature(filters: IWorkItemScheduleFilterState): string {
  return [filters.familyId ?? '', filters.hideArchived ? 'live' : 'stopped'].join('|');
}
